import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {api} from "../utils/gashtaltAPI";
import "../assets/css/Entrance.css";
import {
  toPersianNumber,
  toEnglishNumber,
  filterNonNumeric,
} from "../utils/numberConversion";
import Image from "../assets/images/index.svg";
import Loader from "../components/Loader";
function RecoverPassword() {
  const phoneRegex = /((0?9)|(\+?989))\d{2}\W?\d{3}\W?\d{4}/g;
  const [phoneNumber, setPhoneNumber] = useState("");
  const [loading,setLoading] = useState(false);
  const [error, setError] = useState(false);
  const navigate = useNavigate();

  const handlePhoneNumberChange = (e) => {
    const input = e.target.value;
    setError(!phoneRegex.test(toEnglishNumber(input)));
    const persianNumber = toPersianNumber(filterNonNumeric(input));
    setPhoneNumber(persianNumber);
  };

  const handleSumbit = async (e) => {
    e.preventDefault();
    if (phoneNumber === "" || error) {
      toast.error("فرم ورود را کامل کنید!", {
        position: "bottom-right",
      });

      return;
    }
    setLoading(true);
    try {
      const englishPhoneNumber = toEnglishNumber(phoneNumber);
      const response = await api.post("/api/recoverPassword", {
        phone_number: englishPhoneNumber,
      });
      localStorage["forgotten_password_phone_number"] = englishPhoneNumber;
      toast.success(response.data.message, {
        position: "bottom-right",
      });
      navigate("/ChangePassword");
    } catch (error) {
      setLoading(false);
      if (error.response) {
        const status = error.response.status;
        if (status === 422 || status === 401) {
          toast.error(error.response.data.message, {
            position: "bottom-right",
          });
        }
        return;
      } else if (error.request) {
        toast.error("اتصال اینترنت خود را بررسی کنید!", {
          position: "bottom-right",
        });
        return;
      }
      toast.error("خطایی رخ داد!", {
        position: "bottom-right",
      });
    }
  };
  if (loading) return <Loader />
  return (
    <>
      <div className="entrance-panel row">
        <div className="col-lg-6 form-div">
          <h1>فراموشی رمز عبور</h1>
          <h2>شماره همراه خود را وارد کنید</h2>
          <form method="post" className="container" onSubmit={handleSumbit}>
            <div className="custom-input-group col-md-8 col-10">
              <input
                type="text"
                className={`form-control ${error ? "invalid" : ""}`}
                value={phoneNumber}
                onChange={handlePhoneNumberChange}
                placeholder="شماره همراه"
                autoComplete="true"
              />
              <p className={`form-error ${error ? "visible" : "hidden"}`}>
                !شماره همراه نادرست است
              </p>
            </div>
            <div className="col-md-8 col-10 d-bloc mx-auto text-start my-1">
              <a
                onClick={() => {
                  navigate("/login");
                }}
                className="link"
              >
                بازگشت
              </a>
            </div>
            <button
              className="submit-button btn btn-filled col-md-6 col-8"
              type="submit"
            >
              ثبت
            </button>
          </form>
        </div>
        <div className="image-div col-6 hide-on-mobile">
          <img src={Image} alt="خطا" />
        </div>
      </div>
    </>
  );
}

export default RecoverPassword;
